export interface ILogProps {
  id?: string
  createdAt: string
}

export default class LogEntity {
  private _props: ILogProps

  constructor(props?: ILogProps | null) {
    this._props = EmptyLogPropsFactory(props)
  }

  get props(): ILogProps {
    return this._props
  }

  get clone(): ILogProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get createdAt(): string {
    return this._props.createdAt
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyLogPropsFactory = (props?: Partial<ILogProps> | null): ILogProps => ({
  createdAt: '',
  ...props
})
